// Page client: layout principal du dashboard.
// - Monte la structure commune (sidebar, navbar, bottom navbar).
// - Encapsule les pages enfants dans une ErrorBoundary pour isoler les erreurs.
// - Force le remount a chaque changement de route pour eviter les vues bloquees.
import React, { useState } from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import ClientNavbar from '../../components/client/ClientNavbar';
import ClientSidebar from '../../components/client/ClientSidebar';
import ClientBottomNavbar from '../../components/client/ClientBottomNavbar';
import AIChatAssistant from '../../components/common/AIChatAssistant';
import { ErrorBoundary } from '../../components/common/ErrorBoundary';

const { Outlet, useLocation } = ReactRouterDOM as any;

/**
 * Force le remontage du contenu à chaque changement de route.
 * Corrige le bug où l'URL change mais le composant rendu reste celui de la route précédente
 * (notamment après navigation vers /dashboard/services).
 */
const DashboardOutlet: React.FC = () => {
  const location = useLocation();
  return <Outlet key={location.pathname} />;
};

const ClientLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-surface text-foreground">
      <ClientSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <ClientNavbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        
        <main className="flex-1 overflow-x-hidden overflow-y-auto p-4 sm:p-6 lg:p-8 mt-16 pb-16 lg:pb-8">
          {/* L'Outlet est deja remonte par pathname via DashboardOutlet. */}
          <ErrorBoundary
            onRetry={() => {}}
            fallback={
              <div className="min-h-[200px] flex flex-col items-center justify-center p-6 rounded-lg border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-950/30">
                <p className="font-semibold text-red-800 dark:text-red-200 mb-2">Cette page a rencontré une erreur</p>
                <p className="text-sm text-red-700 dark:text-red-300 mb-4 text-center">
                  Utilisez le menu pour aller sur une autre page, ou rechargez l&apos;application.
                </p>
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="px-4 py-2 rounded-lg bg-primary-500 text-white font-medium hover:bg-primary-400"
                >
                  Recharger la page
                </button>
              </div>
            }
          >
            <DashboardOutlet />
          </ErrorBoundary>
        </main>
        <ClientBottomNavbar />
        <AIChatAssistant />
      </div>
    </div>
  );
};

export default ClientLayout;
